<template>
  <router-view/>
</template>

<script>
export default {
	name: 'app',
};
</script>

<style>
@font-face {
	font-family: 'Hello';
	src: url('~@/assets/Hello.ttf');
}

@font-face {
	font-family: 'Avenir Next';
	src: url('~@/assets/AvenirNextLTPro-Regular.otf');
}

@font-face {
  font-family: 'GoldenBloom';
  src: url('~@/assets/Golden Bloom Regular.otf');
}

@font-face {
  font-family: 'Monserrat';
  src: url('~@/assets/Monserat/Montserrat-Regular.ttf');
}

body {
	margin: 0;
	overflow: auto;
}

h4 {
	font-size: 20px;
}

button {
	cursor: pointer;
	border: none;
	background: none;
}
</style>
